export default __webpack_public_path__ + "static/media/office-profile.41b25ea3.svg";